export const skills = [
    {
        title: 'Languages',
        skills: ['JavaScript', 'Python', 'Node.js', 'HTML5', 'CSS3'],
    },
    {
        title: 'Front End',
        skills: [
            'React',
            'React Hooks',
            'Gatsby',
            'Redux',
            'React-Testing Library',
            'Formik',
            'Ant Design',
            'Material UI',
        ],
    },
    {
        title: 'Back End',
        skills: [
            'Express',
            'Knex',
            'Django',
            'Flask',
            'GraphQL',
            'Google Firestore',
            'Jest',
            'RESTful APIs',
        ],
    },
    {
        title: 'Computer Science',
        skills: ['Algorithms', 'Data Structures', 'Graph Traversals'],
    },
];
